import { useState, useEffect, Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import useStyles from "./styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import LooksTwoOutlinedIcon from "@material-ui/icons/LooksTwoOutlined";
import Avatar from "@material-ui/core/Avatar";

const Login2FA = ({ returnUrl, ...props }: any) => {
  var classes = useStyles();
  const urlBase: string = `/api/authenticate2FA`;

  const [providers, setProviders] = useState<any[]>([]);
  const [response, setResponse] = useState("");
  const [code, setCode] = useState("");

  useEffect(() => {
    (async () => {
      const llamada3 = await fetch(urlBase + "/Providers", {
        method: "GET",
        credentials: "include",
      });
      const data = await llamada3.json();
      setProviders(data);
    })();
  }, [urlBase]);

  const SendCode = async (e: any, provider: string) => {
    e.stopPropagation();
    e.preventDefault();
    const llamada = await fetch(urlBase + "/SendCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(provider),
    });
    const data = await llamada.text();
    setResponse(data);
  };

  const VerifyCode = async (e: any, provider: string) => {
    e.stopPropagation();
    e.preventDefault();
    const llamada = await fetch(`${urlBase}/VerifyCode/?ReturnUrl=${encodeURIComponent(returnUrl)}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
          provider,
          code
      }),
    });
    const data = await llamada.json();
    if (data) {
        window.location = returnUrl;
      }
  };

  return (
    <Fragment>
      <Avatar className={classes.avatar}>
        <LooksTwoOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Please Select your Second Method
      </Typography>
      <form className={classes.form} noValidate>
        {providers.map((provider, index) => (
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            key={index}
            onClick={(e: any) => SendCode(e, provider)}
          >
            {provider}
          </Button>
        ))}
      </form>
      {response.endsWith("Step") && (
        <form className={classes.form} noValidate>
          <Typography component="h2" variant="h5">
            Please enter your verify code
          </Typography>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="code"
            label="Verify Code"
            name="code"
            autoComplete=""
            autoFocus
            onChange={(e) => setCode(e.target.value)}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={(e: any) => VerifyCode(e, response.split('Step')[0])}
          >
              Verify!!
          </Button>
        </form>
      )}
    </Fragment>
  );
};

export default Login2FA;
